import { FlashAutoRounded } from "@mui/icons-material";
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Tooltip,
} from "@mui/material";
import { useEffect } from "react";
import { useRef } from "react";
import { useState } from "react";
import { useDispatch } from "react-redux";
import { CommonShortCutAction } from "../Store/CommonShortCutsReducer";

const ReSchedulementConfirmDialog = (props) => {
  const handleClose = (isClear) => {
    props.clickCancel(isClear);
  };

  const handleOk = () => {
    props.clickOK();
  };
  const dispatch = useDispatch();
  //shortcut key
  const yesRef = useRef(null);
  const cancelRef = useRef(null);
  const closeRef = useRef(null);

  useEffect(() => {
    window.addEventListener("keydown", onKeyUnmountEventHandler);
    window.addEventListener("keyup", onKeyPressEventHandler);
    return () => {
      window.removeEventListener("keydown", onKeyUnmountEventHandler);
      window.removeEventListener("keyup", onKeyPressEventHandler);
    };
  }, []);
  const onKeyUnmountEventHandler = (event) => {
    if (event.ctrlKey) {
      dispatch(
        CommonShortCutAction.removeDefaultShortCutValue({
          event: event,
          screen: "reSchedulement",
        })
      );
    }
  };
  const onKeyPressEventHandler = (event) => {
    let refList = {
      yesRef: yesRef,
      cancelRef: cancelRef.current !== null ? cancelRef : null,
      closeRef: closeRef.current !== null ? closeRef : null,
    };

    if (event.ctrlKey) {
      dispatch(
        CommonShortCutAction.getShortCutValue({
          event: event,
          refs: refList,
          screen: "reSchedulement",
        })
      );
    }
  };

  return (
    <>
      <Dialog
        aria-describedby="alert-dialog-slide-description"
        open={props.openConfirmDialog}
        aria-labelledby="alert-dialog-title"
      >
        {props.messageType === "confirm" ? (
          <DialogTitle>{"Confirmation"}</DialogTitle>
        ) : (
          <DialogTitle>{"Information"}</DialogTitle>
        )}
        <DialogContent>
          <DialogContentText id="alert-dialog-slide-description">
            {props.confirmMessage}
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          {props.messageType === "confirm" ? (
            <>
              <Tooltip title="Ctrl+Q" placement="top">
                <Button
                  onClick={() => handleClose(false)}
                  sx={{ fontWeight: "bold" }}
                  autoFocus
                  ref={cancelRef}
                >
                  Cancel
                </Button>
              </Tooltip>
              <Tooltip title="Ctrl+Y" placement="top">
                <Button
                  onClick={handleOk}
                  sx={{ fontWeight: "bold" }}
                  disabled={props.yesButtonDisableHandler}
                  ref={yesRef}
                >
                  Yes
                </Button>
              </Tooltip>
            </>
          ) : (
            <Tooltip title="Ctrl+Q" placement="top">
              <Button
                onClick={() => handleClose(true)}
                sx={{ fontWeight: "bold" }}
                autoFocus
                ref={closeRef}
              >
                Close
              </Button>
            </Tooltip>
          )}
        </DialogActions>
      </Dialog>
    </>
  );
};

export default ReSchedulementConfirmDialog;
